import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-taxonomy-stack-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './taxonomy-stack-loader.component.html',
  styleUrl: './taxonomy-stack-loader.component.scss'
})
export class TaxonomyStackLoaderComponent {
  taxonomyCount = 4;
  testCount = 3;
}
